import { Patterns } from "../constants/patterns";
import { DomUtils } from "../utils/domUtils";

export const ValidatedInputInvalidClassName = "invalid";

export class ValidatedInput {
	static Init(inputElem) {
		return new ValidatedInput(inputElem);
	}

	constructor(inputElem) {
		inputElem = DomUtils.GetElement(inputElem);

		this._inputElem = inputElem;

		this._inputElem.validate = () => this._Validate();
		this._inputElem.resetValidationState = () => this._ResetValidationState();

		this._inputElem.addEventListener("keyup", (e) => {
			if (!!this._inputElem.dataset.invalid) {
				this._Validate();
			}
		});
	}

	_Validate() {
		this._ResetValidationState();

		let result = null;

		const value = this._inputElem.value;

		if (this._inputElem.required && !value) {
			result = result || {};
			result.required = true;

			this._inputElem.dataset.required = true;
		}

		if (!!this._inputElem.pattern) {
			const pattern = Patterns[this._inputElem.pattern];
			if (!pattern) {
				console.warn(`Pattern ${this._inputElem.pattern} is not defined!`);
			}
			else if (!pattern.test(value)) {
				result = result || {};
				result.pattern = true;

				this._inputElem.dataset.pattern = true;
			}
		}

		if (!!result) {
			this._inputElem.dataset.invalid = true;
			this._inputElem.classList.add(ValidatedInputInvalidClassName);
		}

		return result;
	}

	_ResetValidationState() {
		delete this._inputElem.dataset.invalid;
		delete this._inputElem.dataset.required;
		delete this._inputElem.dataset.pattern;

		this._inputElem.classList.remove(ValidatedInputInvalidClassName);
	}
}
